module.exports = __webpack_public_path__ + "files/ca5432feaabe0145b867d2e582fc2ea1.png";